/* created by CoolGuy on 2019/2/21
 * 这个本来也应该归到Info上的，后来觉得有点烦，主要是想引用ref之类的，后来就放弃了
  * */
import React from 'react'
import Editor from 'braft-editor';
import 'braft-editor/dist/index.css';
import './index.scss';
// 不要connect任何东西哦，否则ref指向有问题
export default class EditorDemo extends React.Component {

    // submitContent = async () => {
    //     // 在编辑器获得焦点时按下ctrl+s会执行此方法
    //     // 编辑器内容提交到服务端之前，可直接调用editorState.toHTML()来获取HTML格式的内容
    //     const htmlContent = this.state.editorState.toHTML()
    //     console.log(htmlContent);
    //     // const result = await saveEditorContent(htmlContent)
    // }
    constructor(props) {
      super(props);

      this.state = {
        length:0
      };
    }

    onChange = (e)=>{
      let {onChange} = this.props;

      if(e) {
        try {
          this.setState({
            length:(e.toText() || "").length
          });
        }catch(err) {

        }
      }

      onChange(e);
    };

    render () {
        const { editorState, showLength, maxLength} = this.props;
        return (
            <div className="braft-editor-wrapper">
              <Editor
                  style={{border:'1px solid #ccc'}}
                  contentStyle={{height:100}}
                  value={editorState}
                  onChange={this.onChange}
                  // onSave={this.submitContent}
                  controls={[
                      // 'undo', 'redo', 'separator',
                      'font-size', 'text-color', 'bold', 'italic', 'underline', 'separator',
                      'emoji',  'separator',
                      'link', 'separator', 'hr'
                  ]}
              />
              {showLength ? (
                <span className={this.state.length > maxLength ? 'count error' : 'count'}>{this.state.length}/{maxLength}</span>
              ) : null}
            </div>
        )

    }

}



// WEBPACK FOOTER //
// ./src/components/RichEditor/index.js